/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useTenant } from "hooks/settings";
import { Loaded, loadedEndpoint } from "models/loaded";
import {
  StrategyDashboardDeliveryData,
  useGetStrategyDashboardDeliveriesAndPurchasesQuery,
} from "src/store/api/generatedApi";
import {
  DeliveryTimeSeries,
  DeliveryTimeSeriesKey,
  GroupedDeliverySeries,
} from "../types";

export const useStrategyDashboardDeliveries = (
  start?: string,
  end?: string
): Loaded<GroupedDeliverySeries> => {
  const loadedRawData = loadedEndpoint(
    useGetStrategyDashboardDeliveriesAndPurchasesQuery({
      start,
      end,
      tenantName: useTenant(),
    })
  );
  if (loadedRawData.status === "success") {
    return {
      status: "success",
      data: buildGroupedDeliverySeries(loadedRawData.data),
      fetching: loadedRawData.fetching,
    };
  }
  return loadedRawData;
};

const buildGroupedDeliverySeries = (
  data: StrategyDashboardDeliveryData
): GroupedDeliverySeries => {
  const stringKeyKeyMap: Record<string, DeliveryTimeSeriesKey> = {};
  const stringKeyValuesMap: Record<string, DeliveryTimeSeries> = {};

  for (const item of data.delivery_series) {
    const key: DeliveryTimeSeriesKey = {
      materialName: item.material_name,
    };
    const stringKey = JSON.stringify(key);
    stringKeyKeyMap[stringKey] = key;

    const value = stringKeyValuesMap[stringKey] ?? {
      date: [],
      deliveryMass: [],
      deliveryMassMtd: [],
      monthPurchasedMass: [],
      monthExpectedMass: [],
      deliveredFraction: [],
      expectedFraction: [],
      expectedMassMtd: [],
    };
    value.date.push(item.delivered_date);
    value.deliveryMass.push(item.delivered_mass);
    value.deliveryMassMtd.push(item.delivered_mass_mtd);
    value.monthPurchasedMass.push(item.month_purchased_mass);
    value.monthExpectedMass.push(item.month_expected_mass);
    value.deliveredFraction.push(item.delivered_fraction);
    value.expectedFraction.push(item.expected_fraction);
    value.expectedMassMtd.push(item.expected_mass_mtd);
    stringKeyValuesMap[stringKey] = value;
  }

  const values: [DeliveryTimeSeriesKey, DeliveryTimeSeries][] = Object.entries(
    stringKeyKeyMap
  ).map(([stringKey, key]) => [key, stringKeyValuesMap[stringKey]!]);

  return {
    values,
    availableMaterialNames: data.materials,
  };
};
